/* global jQuery */
import actionTypes from '../../constants/actionTypes'
import { replace, push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { gamePackage } from '../../lib/transform/parsers/rugby'

/**
 * generate a location replace action
 * @param  {Object} params - router params
 * @return {Object}        - location replace action
 */
export function getErrorRedirect(params) {
  let { sport, pageType } = params
  // default to home page
  let redirectPath = '/'

  // respective sport page
  if (typeof sport === 'string') {
    redirectPath = `/${sport}/`

    // respective section page
    if (typeof pageType === 'string') {
      redirectPath += `${pageType}/`
    }
  }

  return replace(redirectPath)
}

/**
 * set the device type
 * @param {Number} currentWidth - current width of the device
 * @return {Object} action
 */
export function setDeviceType(currentWidth) {
  return {
    type: actionTypes.SET_DEVICE_TYPE,
    currentWidth
  }
}

export function bindRouterPush(dispatch) {
  return bindActionCreators(push, dispatch)
}

export function updateCommentaryFbStatus(status) {
  return {
    type: actionTypes.COMM_FB_STATUS,
    status
  }
}

export function commentaryFbInprogress() {
  return updateCommentaryFbStatus('SUBMITTING')
}

export function commentaryFbSuccess() {
  return updateCommentaryFbStatus('SUCCESS')
}

export function commentaryFbError() {
  return updateCommentaryFbStatus('ERROR')
}

export function postCommentryFeedback(data) {
  return (dispatch) => {
    try{
      dispatch(commentaryFbInprogress())
      jQuery.ajax({
        url: '//submit.cricinfo.com/ci/content/submit/forms/commentary_feedback_jsonp.json',
        jsonp: 'callback',
        dataType: 'jsonp',
        data,
        success: function () {
          dispatch(commentaryFbSuccess())
        }
      })
    } catch (err) {
      dispatch(commentaryFbError())
    }
  }
}

export function resetScoreboard() {
  return {
    type: actionTypes.RESET_SCOREBOARD
  }
}

export function resetGamePackage() {
  return {
    type: actionTypes.RESET_GAMEPACKAGE
  }
}



// WEBPACK FOOTER //
// ../app/actions/utils/index.js